import { api } from '@config/api';
import type { Sincronizacao, UltimaSincronizacao } from '../types/Sincronizacao';

export const sincronizacaoService = {
  ultima: (id: string) =>
    api.get<UltimaSincronizacao>(`/campanhas/${id}/sincronizacoes/ultima`).then((r) => r.data),
  sincronizar: (id: string) =>
    api.post<Sincronizacao>(`/campanhas/${id}/sincronizacoes`).then((r) => r.data),
};
